import { Info, InfoOutlined } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import { HtmlTooltip } from "components/admin/UI/InfoTooltip";

const FieldInfo = ({ infoText, crmKey }) => {
  if (!infoText?.length) return null;
  return (
    <HtmlTooltip
      placement="right-end"
      arrow
      title={
        <Stack p={1} direction={"row"} alignItems={"flex-start"} gap={1}>
          <InfoOutlined sx={{ fontSize: 20 }} />
          <Typography
            sx={{
              wordBreak: "break-word",
            }}
            variant="body2"
          >
            {infoText}
          </Typography>
        </Stack>
      }
    >
      <Info />
    </HtmlTooltip>
  );
};

export default FieldInfo;
